module.exports = __webpack_public_path__ + "static/media/ic_general_arrow_down.406e6874.svg";